import React from "react"
import colors from "../../Constants/colors"
import PYPLayoutContainer from "../PYPLayoutContainer/PYPLayoutContainer.js"

import ButtonSelection from "../ButtonSelection/ButtonSelection"
import PYPPartTitleContent from "../PYPPartTitleContent/PYPPartTitleContent.js"
import SkeletonButtons from "../SkeletonButtons/SkeletonButtons.js"

import "./LayoutButtonSelectionStage2MetaData.css"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Actions from "../../Redux/Actions"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"

class LayoutButtonSelectionStage2MetaData extends React.Component {
  constructor(props) {
    super(props)
    this.changeHandler = this.changeHandler.bind(this)
  }

  isEMpowered() {
    return (
      Number(this.props.pyp?.navigation?.currentCourseId) ===
      ADDITIONAL_COURSE_ID
    )
  }

  hasLoadedButtonPartData() {
    const loadedPartDataId = this.props.currentPart?.partData
    const partDataPayload =
      loadedPartDataId &&
      this.props.pyp?.partData?.byId?.[loadedPartDataId]?.data
    return (
      partDataPayload != null &&
      Array.isArray(partDataPayload.buttonValues)
    )
  }

  shouldFetchPartData() {
    if (
      !this.props.initializedPart ||
      this.props.pyp.savingPYP ||
      this.props.fetchingPartData ||
      !this.props.currentPart
    ) {
      return false
    }
    if (this.isEMpowered() && this.hasLoadedButtonPartData()) {
      return false
    }
    return true
  }

  componentDidMount() {
    if (this.shouldFetchPartData()) {
      this.props.fetchPartData()
    }
  }

  componentDidUpdate(prevProps) {
    // PYP only: refetch when saving completes. eMpowered keeps Redux selections.
    if (prevProps.pyp.savingPYP && !this.props.pyp.savingPYP) {
      if (!this.isEMpowered() && this.shouldFetchPartData()) {
        this.props.fetchPartData()
      }
    }

    // Fetch data when part becomes initialized (skip eMpowered if already loaded)
    if (!prevProps.initializedPart && this.props.initializedPart) {
      if (this.shouldFetchPartData()) {
        this.props.fetchPartData()
      }
    }
  }

  changeHandler(inputData) {
    this.props.setButtonSelection(inputData[0])
  }

  render() {
    const buttonValues = this.props.buttonValues || []
    const buttonComponent = buttonValues.length > 0 ? (
      <ButtonSelection
        limit={3}
        changeHandler={this.changeHandler}
        inputData={buttonValues}
        renderComponent={({ inputComponent }) => (
          <div
            style={{
              width: "100%",
              marginBottom: "100px"
            }}
          >
            {inputComponent}
          </div>
        )}
      />
    ) : (
      <SkeletonButtons quantity={10} />
    )

    return (
      <PYPLayoutContainer
        backgroundColor={colors.background}
        style={{ justifyContent: "flex-start" }}
      >
        <div
          className="buttonSelectionStage2Layout"
          style={{ ...styles.buttonSelectionStage2Layout, ...this.props.style }}
        >
          <div>
            <PYPPartTitleContent
              title={this.props.title.title}
              description={this.props.title.description}
            />
          </div>
          {buttonComponent}
        </div>
      </PYPLayoutContainer>
    )
  }
}

const styles = {
  buttonSelectionStage2Layout: {
    width: "100%", // 80%?
    // height: '100vh', //80%?
    overflow: "visible",
    backgroundColor: colors.background,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  inputBoxContainer: {
    width: "100%",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  try {
    const currentPart = state.pyp?.parts?.byId?.[state.pyp?.navigation?.currentPartId]
    const partDataId = currentPart?.partData

    let buttonValues = []
    let metadata = { title: null, description: null }

    const partData =
      partDataId &&
      state.pyp?.partData?.byId?.[partDataId] &&
      state.pyp.partData.byId[partDataId].data
    
    if (partData) {
      // Safely access title
      if (partData.title && Array.isArray(partData.title) && partData.title.length > 0) {
        metadata = partData.title[0]
      }
      
      // Safely access buttonValues
      // For Stage 2, we show only the values that have non-empty buttonSelections (the 10 selected in Stage 1)
      // and mark those with stage === 2 as selected
      if (partData.buttonValues && Array.isArray(partData.buttonValues)) {
        // Filter to only show values that have non-empty buttonSelections (the 10 selected in Stage 1)
        // For Stage 2, we ONLY show the values that were selected in Stage 1 (partId=20)
        // A buttonValue with any selection (stage: null, 1, or 2) was selected in Stage 1
        const stage1Values = partData.buttonValues.filter((buttonValue) => {
          if (!buttonValue) {
            return false
          }
          // Check if buttonSelections exists and is an array with at least one item
          return buttonValue.buttonSelections && 
                 Array.isArray(buttonValue.buttonSelections) && 
                 buttonValue.buttonSelections.length > 0
        })
        
        // Only use the filtered values - never show all values on Stage 2
        buttonValues = stage1Values
          .map((buttonValue) => {
            // Check if this buttonValue has a stage 2 selection
            const hasStage2Selection = buttonValue && 
                                      buttonValue.buttonSelections && 
                                      Array.isArray(buttonValue.buttonSelections) &&
                                      buttonValue.buttonSelections.length > 0 &&
                                      buttonValue.buttonSelections.some((sel) => 
                                        sel && sel.pivot && sel.pivot.stage === 2
                                      )
            
            // Find the stage 2 selection if it exists
            const stage2Selection = buttonValue?.buttonSelections?.find((sel) => 
              sel && sel.pivot && sel.pivot.stage === 2
            ) || (buttonValue?.buttonSelections?.[0] || null)
            
            return {
              value: buttonValue?.name || '',
              id: buttonValue?.id,
              isCustom: buttonValue?.isCustom || false,
              buttonSelection: stage2Selection,
              isSelected: hasStage2Selection || false
            }
          })

        // alphabetize only the non-custom buttons
        const customButtons = buttonValues.filter((value) => value.isCustom)
        const defaultButtons = buttonValues
          .filter((value) => !value.isCustom)
          .sort((a, b) =>
            a.value.toUpperCase() > b.value.toUpperCase()
              ? 1
              : b.value.toUpperCase() > a.value.toUpperCase()
              ? -1
              : 0
          )

        buttonValues = [...customButtons, ...defaultButtons]
      }
    }

    return {
      ...props,
      pyp: state.pyp,
      currentPart,
      partDataId,
      buttonValues: buttonValues || [], // Ensure it's always an array
      title: metadata,
      initializedPart: state.pyp?.initializedPart || false,
      fetchingPartData: state.pyp?.fetchingPartData || false
    }
  } catch (e) {
    // Return safe defaults if there's an error
    return {
      ...props,
      pyp: state.pyp,
      currentPart: null,
      partDataId: null,
      buttonValues: [], // Always return an array
      title: { title: null, description: null },
      initializedPart: state.pyp?.initializedPart || false,
      fetchingPartData: state.pyp?.fetchingPartData || false
    }
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LayoutButtonSelectionStage2MetaData)
)
